(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-address-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mcap]');
  if (!root || root.dataset.mcapBound) return;
  root.dataset.mcapBound = '1';

  var TOKEN   = root.getAttribute('data-sf-token') || '';
  var VER     = root.getAttribute('data-api-version') || '2025-01';
  var VARIANT = root.getAttribute('data-variant') || '';
  var GQL     = '/api/' + VER + '/graphql.json';

  root.querySelector('[data-mcap-ver]').textContent = VER;
  root.querySelector('[data-mcap-var]').textContent = VARIANT || '(not set)';

  var listEl  = root.querySelector('[data-mcap-list]');
  var formEl  = root.querySelector('[data-mcap-form]');
  var logEl   = root.querySelector('[data-mcap-log]');
  var stateEl = root.querySelector('[data-mcap-state]');

  /* ---------------------------------------------------------
     Address book.
     Demo data lives in memory. In production these three
     functions call the FastAPI backend instead:
       loadAddresses  -> GET  /addresses
       saveAddress    -> POST /addresses
       deleteAddress  -> DELETE /addresses/:id
  --------------------------------------------------------- */
  var SEED = [
    { id: 'a1', label: 'Home', firstName: 'Chaitanya', lastName: 'Porwal',
      address1: 'Metro Tower, Vijay Nagar', address2: '4th floor',
      city: 'Indore', province: 'Madhya Pradesh', zip: '452001',
      country: 'India', phone: '+919910926562', isDefault: true },
    { id: 'a2', label: 'Office', firstName: 'Chaitanya', lastName: 'Porwal',
      address1: 'Sunevan, Scheme 54 PU4', address2: '',
      city: 'Indore', province: 'Madhya Pradesh', zip: '452010',
      country: 'India', phone: '+919910926562', isDefault: false }
  ];

  var addresses = SEED.map(function (a) { return Object.assign({}, a); });
  var selectedId = addresses[0] ? addresses[0].id : null;
  var editingId = null;
  var cartId = null;

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (m) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m];
    });
  }

  function render() {
    if (!addresses.length) {
      listEl.innerHTML = '<p style="font-size:13px;color:#6B6357">No saved addresses. Add one to begin.</p>';
      return;
    }
    listEl.innerHTML = addresses.map(function (a) {
      var lines = [a.address1, a.address2, a.city + ', ' + a.province + ' ' + a.zip, a.country, a.phone]
        .filter(Boolean).map(esc).join('<br>');
      return '<div class="mcap__card' + (a.id === selectedId ? ' is-on' : '') + '" data-pick="' + a.id + '">' +
        '<span class="mcap__radio"></span>' +
        '<div class="mcap__cbody">' +
          '<div class="mcap__clabel">' + esc(a.label) +
            (a.isDefault ? '<span class="mcap__pill">Default</span>' : '') + '</div>' +
          '<div class="mcap__ctext">' + esc(a.firstName + ' ' + a.lastName) + '<br>' + lines + '</div>' +
          '<div class="mcap__cacts">' +
            '<button type="button" data-edit="' + a.id + '">Edit</button>' +
            (a.isDefault ? '' : '<button type="button" data-default="' + a.id + '">Set default</button>') +
            '<button type="button" class="is-del" data-del="' + a.id + '">Delete</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
  }

  function log(title, payload) {
    stateEl.textContent = title;
    logEl.textContent = (typeof payload === 'string') ? payload : JSON.stringify(payload, null, 2);
  }

  function step(n, ok) {
    var el = root.querySelector('[data-mcap-s' + n + ']');
    if (el) { el.classList.remove('is-ok', 'is-bad'); el.classList.add(ok ? 'is-ok' : 'is-bad'); }
  }
  function resetSteps() {
    [1,2,3,4].forEach(function (n) {
      var el = root.querySelector('[data-mcap-s' + n + ']');
      if (el) el.classList.remove('is-ok', 'is-bad');
    });
  }

  /* list interactions */
  listEl.addEventListener('click', function (e) {
    var del = e.target.closest('[data-del]');
    if (del) {
      var id = del.getAttribute('data-del');
      addresses = addresses.filter(function (a) { return a.id !== id; });
      if (selectedId === id) selectedId = addresses[0] ? addresses[0].id : null;
      render(); return;
    }
    var def = e.target.closest('[data-default]');
    if (def) {
      var did = def.getAttribute('data-default');
      addresses.forEach(function (a) { a.isDefault = (a.id === did); });
      render(); return;
    }
    var ed = e.target.closest('[data-edit]');
    if (ed) { openForm(ed.getAttribute('data-edit')); return; }

    var card = e.target.closest('[data-pick]');
    if (card) { selectedId = card.getAttribute('data-pick'); render(); }
  });

  /* form */
  function openForm(id) {
    editingId = id || null;
    var a = id ? addresses.filter(function (x) { return x.id === id; })[0] : null;
    root.querySelector('[data-mcap-formtitle]').textContent = a ? 'Edit address' : 'New address';
    formEl.querySelectorAll('[data-f]').forEach(function (input) {
      input.value = a ? (a[input.getAttribute('data-f')] || '') : '';
    });
    if (!a) {
      formEl.querySelector('[data-f="country"]').value = 'India';
      formEl.querySelector('[data-f="province"]').value = '';
    }
    formEl.hidden = false;
    formEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  root.querySelector('[data-mcap-new]').addEventListener('click', function () { openForm(null); });
  root.querySelector('[data-mcap-cancel]').addEventListener('click', function () { formEl.hidden = true; });

  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    var rec = {};
    formEl.querySelectorAll('[data-f]').forEach(function (input) {
      rec[input.getAttribute('data-f')] = input.value.trim();
    });
    if (editingId) {
      addresses = addresses.map(function (a) {
        return a.id === editingId ? Object.assign({}, a, rec) : a;
      });
      selectedId = editingId;
    } else {
      rec.id = 'a' + Date.now();
      rec.isDefault = addresses.length === 0;
      addresses.push(rec);
      selectedId = rec.id;
    }
    editingId = null;
    formEl.hidden = true;
    render();
  });

  root.querySelector('[data-mcap-reset]').addEventListener('click', function () {
    addresses = SEED.map(function (a) { return Object.assign({}, a); });
    selectedId = addresses[0].id;
    cartId = null; resetSteps(); render();
    log('reset', 'Demo data restored.');
  });

  /* ---------------- Storefront API ---------------- */

  function gql(query, variables) {
    return fetch(GQL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); });
  }

  function toShopifyAddress(a) {
    return {
      firstName: a.firstName, lastName: a.lastName,
      address1: a.address1, address2: a.address2 || null,
      city: a.city, province: a.province, zip: a.zip,
      country: a.country, phone: a.phone
    };
  }

  var CART_FIELDS =
    'cart { id checkoutUrl totalQuantity' +
    '  buyerIdentity { email phone countryCode' +
    '    deliveryAddressPreferences { ... on MailingAddress {' +
    '      firstName lastName address1 address2 city province zip country phone } } } }';

  root.querySelector('[data-mcap-checkout]').addEventListener('click', function (e) {
    var btn = e.currentTarget;
    var addr = addresses.filter(function (a) { return a.id === selectedId; })[0];

    if (!TOKEN)   { log('error', 'Set the Storefront API token in the theme editor.'); return; }
    if (!VARIANT) { log('error', 'Set a test variant GID in the theme editor.'); return; }
    if (!addr)    { log('error', 'Select an address first.'); return; }

    btn.disabled = true; resetSteps();
    log('working…', 'Creating cart…');

    var buyer = {
      phone: addr.phone,
      countryCode: (addr.country === 'India' ? 'IN' : 'US'),
      deliveryAddressPreferences: [{ deliveryAddress: toShopifyAddress(addr) }]
    };

    gql(
      'mutation($input: CartInput!) { cartCreate(input: $input) { ' + CART_FIELDS + ' userErrors { field message } } }',
      { input: { lines: [{ merchandiseId: VARIANT, quantity: 1 }], buyerIdentity: buyer } }
    ).then(function (d) {
      if (d.errors) { step(1, false); log('cartCreate failed', d.errors); throw new Error('cartCreate'); }
      var res = d.data.cartCreate;
      if (res.userErrors && res.userErrors.length) { step(1, false); log('userErrors', res.userErrors); throw new Error('userErrors'); }

      step(1, true);
      cartId = res.cart.id;

      /* Update again with the same identity — this is the call the real cart
         page will use when the customer switches address mid-session. */
      return gql(
        'mutation($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {' +
        '  cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) { ' + CART_FIELDS +
        '    userErrors { field message } } }',
        { cartId: cartId, buyerIdentity: buyer }
      );
    }).then(function (d) {
      if (d.errors) { step(2, false); log('buyerIdentityUpdate failed', d.errors); throw new Error('update'); }
      var res = d.data.cartBuyerIdentityUpdate;
      if (res.userErrors && res.userErrors.length) { step(2, false); log('userErrors', res.userErrors); throw new Error('userErrors'); }
      step(2, true);

      var prefs = res.cart.buyerIdentity && res.cart.buyerIdentity.deliveryAddressPreferences;
      var stored = prefs && prefs.length && prefs[0] && prefs[0].address1;
      step(3, !!stored);

      log(stored ? 'address stored on cart' : 'address NOT stored', res.cart);

      if (!stored) {
        step(4, false);
        return;
      }
      window.open(res.cart.checkoutUrl, '_blank', 'noopener');
      step(4, true);
      logEl.textContent = JSON.stringify(res.cart, null, 2) +
        '\n\n--- CHECK THE CHECKOUT TAB ---\n' +
        'Selected: ' + addr.label + ' — ' + addr.address1 + ', ' + addr.city + ' ' + addr.zip + '\n' +
        'Is that the address shown at checkout?\n' +
        'Switch to the other address here and run again to confirm it changes.';
    }).catch(function () { /* already logged */ })
      .then(function () { btn.disabled = false; });
  });

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-topbar-close]').forEach(function(btn){
  btn.addEventListener('click', function(){
    btn.closest('.mc-topbar').classList.add('is-hidden');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-article-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-acar]').forEach(function (root) {
  if (root.dataset.mcBound) return;
  root.dataset.mcBound = '1';

  var track = root.querySelector('[data-mc-acar-track]');
  var prev  = root.querySelector('[data-mc-acar-prev]');
  var next  = root.querySelector('[data-mc-acar-next]');
  if (!track || !prev || !next) return;

  function step() {
    var card = track.querySelector('.mc-acar__card');
    if (!card) return track.clientWidth * 0.8;
    // One card plus the gap, so a click lands cleanly on the next snap point
    // rather than part-way across two.
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return card.offsetWidth + gap;
  }

  function sync() {
    var max = track.scrollWidth - track.clientWidth;
    // 2px of slack: sub-pixel layout leaves scrollLeft a hair short of max,
    // which would keep the arrow visible with nowhere left to go.
    prev.hidden = track.scrollLeft <= 2;
    next.hidden = track.scrollLeft >= max - 2;
  }

  prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });

  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-article"]) return;
  try {
    

/* Publish the sticky header's real height so the pinned sidebar can clear it.
   #header-group is the sticky container, not .mc-header — the header only
   sticks within its parent's bounds. */
(function () {
  function setHeadHeight() {
    var head = document.querySelector('#header-group') || document.querySelector('.mc-header');
    if (!head) return;
    document.documentElement.style.setProperty('--mc-head-h', head.offsetHeight + 'px');
  }
  setHeadHeight();
  window.addEventListener('resize', setHeadHeight);
  // The announcement bar can be dismissed, which changes the height.
  window.addEventListener('load', setHeadHeight);
})();
/* "16 Hrs Ago" — rendered in the browser because a server-rendered relative
   time is wrong the moment the page is cached. */
document.querySelectorAll('[data-mc-ago]').forEach(function (el) {
  var then = parseInt(el.getAttribute('data-mc-ago'), 10);
  if (!then) return;
  var mins = Math.floor((Date.now() / 1000 - then) / 60);
  var out;
  if (mins < 60) out = mins + ' Min' + (mins === 1 ? '' : 's') + ' Ago';
  else if (mins < 1440) { var h = Math.floor(mins / 60); out = h + ' Hr' + (h === 1 ? '' : 's') + ' Ago'; }
  else {
    var d = Math.floor(mins / 1440);
    // Past a fortnight the date above is more use than "97 Days Ago".
    if (d > 14) { el.remove(); return; }
    out = d + ' Day' + (d === 1 ? '' : 's') + ' Ago';
  }
  el.textContent = out;
});

/* Native share sheet where it exists — on a phone that is what people
   expect. Falls back to copying the link. */
document.querySelectorAll('[data-mc-share]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var url = btn.getAttribute('data-url');
    var title = btn.getAttribute('data-title');
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var was = btn.lastChild.textContent;
        btn.lastChild.textContent = ' Link copied';
        setTimeout(function () { btn.lastChild.textContent = was; }, 1800);
      }).catch(function () {});
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-blog-grid"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-bgrid]').forEach(function (root) {
  if (root.dataset.mcBound) return;
  root.dataset.mcBound = '1';

  var grid  = root.querySelector('[data-mc-bgrid-grid]');
  var pager = root.querySelector('[data-mc-bgrid-pager]');
  var empty = root.querySelector('[data-mc-bgrid-empty]');
  var tabs  = root.querySelectorAll('[data-mc-cat]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mc-card]'));
  var per   = parseInt(root.getAttribute('data-per-page'), 10) || 9;

  /* Liquid builds the grid one blog at a time, so "All" listed every article
     from the first blog before any from the second — making its first page a
     copy of the first tab's. Reordering by date once, up front, makes every
     view newest-first regardless of which blog a post came from.

     The DOM is reordered, not just the array: cards are shown and hidden with
     a class, so the browser paints them in document order. Sorting the array
     alone would change WHICH nine appear, but not the order they appear in. */
  cards.sort(function (a, b) {
    return (parseInt(b.dataset.date, 10) || 0) - (parseInt(a.dataset.date, 10) || 0);
  });
  var frag = document.createDocumentFragment();
  cards.forEach(function (c) { frag.appendChild(c); });
  grid.appendChild(frag);

  var cat = (root.querySelector('[data-mc-cat].is-on') || {}).dataset;
  cat = cat ? cat.mcCat : '*';
  var page = 1;

  function matching() {
    return cat === '*' ? cards : cards.filter(function (c) { return c.dataset.cat === cat; });
  }

  function paint() {
    var list = matching();
    var pages = Math.max(1, Math.ceil(list.length / per));
    if (page > pages) page = pages;

    var start = (page - 1) * per;
    var end = start + per;

    cards.forEach(function (c) { c.classList.add('is-out'); });
    list.slice(start, end).forEach(function (c) { c.classList.remove('is-out'); });

    if (empty) empty.hidden = list.length > 0;
    renderPager(pages);
  }

  /* Windowed page numbers with ellipses — 1 2 3 … 67 68, as in the design.
     A flat list of every page is unusable past about ten. */
  function renderPager(pages) {
    if (!pager) return;
    if (pages < 2) { pager.innerHTML = ''; return; }

    var want = [1, pages, page, page - 1, page + 1];
    var nums = want.filter(function (n, i, a) {
      return n >= 1 && n <= pages && a.indexOf(n) === i;
    }).sort(function (a, b) { return a - b; });

    var html = '', prev = 0;
    nums.forEach(function (n) {
      if (n - prev > 1) html += '<span class="mc-bgrid__pg mc-bgrid__pg--gap">…</span>';
      html += '<button type="button" class="mc-bgrid__pg' + (n === page ? ' is-on' : '') +
              '" data-mc-page="' + n + '"' + (n === page ? ' aria-current="page"' : '') +
              '>' + n + '</button>';
      prev = n;
    });
    pager.innerHTML = html;
  }

  root.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-mc-cat]');
    if (tab) {
      cat = tab.dataset.mcCat;
      page = 1;
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      paint();
      return;
    }

    var pg = e.target.closest('[data-mc-page]');
    if (pg) {
      page = parseInt(pg.dataset.mcPage, 10) || 1;
      paint();
      // Scroll to the top of the grid, not the page — the reader's place is
      // the article list, and jumping to the masthead loses it.
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  paint();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.MCCart) return;
  var root, itemsEl;
  var PCACHE = {};
  function money(cents){
    var v = cents / 100;
    return '\u20B9' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  // Move the drawer to <body>. Shopify wraps every section in its own div,
  // and any ancestor with transform, filter or contain makes position:fixed
  // resolve against THAT ancestor rather than the viewport — so the panel was
  // only as tall as its section and the bottom nav painted over it. The
  // header drawer already does this; the cart never did.
  function portal(){
    var d = document.querySelector('[data-mc-cart-drawer]');
    if (d && d.parentNode !== document.body) document.body.appendChild(d);
    return d;
  }
  function el(){ return portal(); }
  function render(cart){
    root = el(); if (!root) return;
    itemsEl = root.querySelector('[data-mc-cd-items]');
    var empty = root.querySelector('[data-mc-cd-empty]');
    if (!cart.items.length){
      itemsEl.innerHTML = '';
      empty.hidden = false;
      root.classList.add('is-empty');
    } else {
      empty.hidden = true;
      root.classList.remove('is-empty');
      itemsEl.innerHTML = cart.items.map(function(it){
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="">' : '';
                // Size, Mix and Texture are all Shopify variant options, so they
        // arrive together in options_with_values. Split by option name so
        // the weight sits on its own line and the two customisation choices
        // share the one below it.
        var weight = [], custom = [];
        (it.options_with_values || []).forEach(function(o){
          if (!o.value || o.value === 'Default Title') return;
          if (/size|weight/i.test(o.name)) weight.push(o.value);
          else custom.push(o.value);
        });
        // Texture can also ride along as a line-item property depending on
        // which flow added the line. Underscore-prefixed keys (_Region) are
        // internal and must stay hidden from the customer.
        Object.keys(it.properties || {}).forEach(function(k){
          if (k.charAt(0) !== '_' && it.properties[k]) custom.push(it.properties[k]);
        });
        var line1 = custom.join(' · ');   // Mix · Texture
        var line2 = weight.join(' · ');   // 2kg
        var minus = it.quantity > 1
          ? '<button class="mc-cd__qbtn" type="button" data-mc-cd-dec="' + it.key + '" aria-label="Decrease"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg></button>'
          : '<button class="mc-cd__qbtn" type="button" data-mc-cd-del="' + it.key + '" aria-label="Remove"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M4.375 13.125C4.03125 13.125 3.73698 13.0026 3.49219 12.7578C3.2474 12.513 3.125 12.2188 3.125 11.875V3.75H2.5V2.5H5.625V1.875H9.375V2.5H12.5V3.75H11.875V11.875C11.875 12.2188 11.7526 12.513 11.5078 12.7578C11.263 13.0026 10.9688 13.125 10.625 13.125H4.375ZM10.625 3.75H4.375V11.875H10.625V3.75ZM5.625 10.625H6.875V5H5.625V10.625ZM8.125 10.625H9.375V5H8.125V10.625Z" fill="#1D1B20"/></svg></button>';
        return '<div class="mc-cd__li">' +
          '<a class="mc-cd__li-img" href="' + it.url + '">' + img + '</a>' +
          '<div><a class="mc-cd__li-t" href="' + it.url + '">' + it.product_title + '</a>' +
            (line1 ? '<div class="mc-cd__li-s">' + line1 + '</div>' : '') +
            (line2 ? '<div class="mc-cd__li-s mc-cd__li-w">' + line2 + '</div>' : '') +
          '</div>' +
          '<div class="mc-cd__li-right"><span class="mc-cd__li-p">' + money(it.line_price) + '</span>' +
            '<span class="mc-cd__qty">' + minus +
              '<span class="mc-cd__qn">' + it.quantity + '</span>' +
              '<button class="mc-cd__qbtn" type="button" data-mc-cd-inc="' + it.key + '" aria-label="Increase"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button>' +
            '</span>' +
          '</div></div>';
      }).join('');
    }
    // ---- savings: cart discounts + MRP (compare-at) difference ----
    var savedRow = root.querySelector('[data-mc-cd-savedrow]');
    var saved = 0;
    cart.items.forEach(function(it){
      if (it.original_line_price > it.line_price) saved += it.original_line_price - it.line_price;
    });
    if (cart.total_discount) saved += cart.total_discount;
    root.querySelector('[data-mc-cd-total]').textContent = money(cart.total_price);
    function paintSaved(extra){
      var total = saved + (extra || 0);
      if (total > 0){
        savedRow.hidden = false;
        root.querySelector('[data-mc-cd-saved]').textContent = money(total);
      } else {
        savedRow.hidden = true;
      }
    }
    paintSaved(0);
    // compare-at prices aren't in /cart.js, so pull each product once and cache
    var handles = [];
    cart.items.forEach(function(it){ if (it.handle && handles.indexOf(it.handle) === -1) handles.push(it.handle); });
    Promise.all(handles.map(function(h){
      if (PCACHE[h]) return Promise.resolve(PCACHE[h]);
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(p){ PCACHE[h] = p; return p; })
        .catch(function(){ return null; });
    })).then(function(){
      var mrpSaved = 0;
      cart.items.forEach(function(it){
        var p = PCACHE[it.handle];
        if (!p) return;
        var v = null;
        for (var i = 0; i < p.variants.length; i++){
          if (p.variants[i].id === it.variant_id){ v = p.variants[i]; break; }
        }
        if (v && v.compare_at_price && v.compare_at_price > v.price){
          mrpSaved += (v.compare_at_price - v.price) * it.quantity;
        }
      });
      paintSaved(mrpSaved);
    });
    // ---- free shipping meter: fill lands exactly on each pip ----
    var t1 = parseInt(root.getAttribute('data-t1'), 10) || 0;
    var t2 = parseInt(root.getAttribute('data-t2'), 10) || 0;
    var t3 = parseInt(root.getAttribute('data-t3'), 10) || 0;
    var total = cart.total_price;
    var stops = [
      { amt: t1, pos: 16.666, label: root.getAttribute('data-t1l') },
      { amt: t2, pos: 50,     label: root.getAttribute('data-t2l') },
      { amt: t3, pos: 83.333, label: root.getAttribute('data-t3l') }
    ].filter(function(st){ return st.amt > 0; });
    if (!stops.length){ stops = [{ amt: 0, pos: 100, label: '' }]; }
    var pct = 0, prevAmt = 0, prevPos = 0, next = null;
    for (var i = 0; i < stops.length; i++){
      var st = stops[i];
      if (total >= st.amt){
        pct = st.pos; prevAmt = st.amt; prevPos = st.pos;
      } else {
        var span = st.amt - prevAmt;
        var ratio = span > 0 ? (total - prevAmt) / span : 0;
        pct = prevPos + (st.pos - prevPos) * Math.max(0, Math.min(1, ratio));
        next = st;
        break;
      }
    }
    if (!next) pct = 100;
    root.querySelector('[data-mc-cd-fill]').style.width = pct + '%';
    stops.forEach(function(st, idx){
      var pip = root.querySelector('[data-mc-cd-pip="' + (idx + 1) + '"]');
      if (pip) pip.classList.toggle('is-hit', total >= st.amt);
    });
    var msg = root.querySelector('[data-mc-cd-shipmsg]');
    if (next){
      var tpl = root.getAttribute('data-ship-msg') || '';
      var label = (next.label || '').trim();
      var amount = money(next.amt - total);
      var out;
      if (tpl.indexOf('{label}') > -1){
        out = tpl.replace('{amount}', amount).replace('{label}', label || 'free shipping');
      } else if (tpl.indexOf('{amount}') > -1){
        // older saved message with a hardcoded reward name — swap the reward in
        out = tpl.replace('{amount}', amount);
        if (label){
          out = out.replace(/away from .*$/i, 'away from ' + label);
        }
      } else {
        out = 'You are ' + amount + ' away from ' + (label || 'free shipping');
      }
      msg.textContent = out;
    } else {
      msg.textContent = root.getAttribute('data-ship-done') || 'You have unlocked all rewards!';
    }
    document.dispatchEvent(new CustomEvent('mc:cart:updated', { detail: { cart: cart } }));
  }
  function fetchCart(cb){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ render(c); if (cb) cb(c); });
  }
  function change(key, qty){
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); }).then(render);
  }
  function open(){
    // Re-portal on open: the theme editor re-renders sections, which puts a
    // fresh copy of the drawer back inside its wrapper.
    root = portal(); if (!root) return;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ root.classList.add('is-open'); });
    fetchCart();
  }
  function close(){
    root = el(); if (!root) return;
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function(){ root.hidden = true; }, 300);
  }
  window.MCCart = {
    open: open, close: close, refresh: fetchCart,
    change: change,
    sync: function(){ fetchCart(); }
  };
  // broadcast once on load so cards can show their stepper state
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ portal(); fetchCart(); });
  } else { portal(); fetchCart(); }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-mc-cd-close]')) { close(); return; }
    var inc = e.target.closest('[data-mc-cd-inc]');
    if (inc){ var k = inc.getAttribute('data-mc-cd-inc');
      var n = parseInt(inc.parentNode.querySelector('.mc-cd__qn').textContent, 10) || 1;
      change(k, n + 1); return; }
    var dec = e.target.closest('[data-mc-cd-dec]');
    if (dec){ var k2 = dec.getAttribute('data-mc-cd-dec');
      var n2 = parseInt(dec.parentNode.querySelector('.mc-cd__qn').textContent, 10) || 1;
      change(k2, Math.max(0, n2 - 1)); return; }
    var del = e.target.closest('[data-mc-cd-del]');
    if (del){ change(del.getAttribute('data-mc-cd-del'), 0); return; }
    // open drawer instead of navigating to /cart
    var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (cartLink && el()){ e.preventDefault(); open(); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  // intercept every native add-to-cart form
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!el()) return;
    // let Buy Now (return_to=/checkout) pass through
    var ret = form.querySelector('[name="return_to"]');
    if (ret && ret.value) return;
    e.preventDefault();
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function(r){ return r.json(); })
      .then(function(){ open(); })
      .catch(function(){ form.submit(); });
  }, true);
  // opened by the customisation popup after it adds a line
  document.addEventListener('mc:cart:added', function(){ open(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-checkout-spike"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mck]');
  if (!root || root.dataset.mckBound) return;
  root.dataset.mckBound = '1';

  var TOKEN = root.getAttribute('data-sf-token') || '';
  var VER   = root.getAttribute('data-api-version') || '2025-01';
  var URL_  = '/api/' + VER + '/graphql.json';       // same-origin: no CORS

  var logEl = root.querySelector('[data-mck-log]');
  var statusEl = root.querySelector('[data-mck-status]');
  var verdictEl = root.querySelector('[data-mck-verdict]');
  root.querySelector('[data-mck-ver]').textContent = VER;

  var state = { customerToken: null, cartId: null, checkoutUrl: null, plainUrl: null };

  function log(title, payload, kind) {
    var cls = kind === 'ok' ? 'mck__ok' : kind === 'bad' ? 'mck__bad' : 'mck__warn';
    statusEl.innerHTML = '<span class="' + cls + '">' + title + '</span>';
    logEl.textContent = '[' + new Date().toLocaleTimeString('en-IN', { hour12: false }) + '] ' +
      title + '\n\n' + (typeof payload === 'string' ? payload : JSON.stringify(payload, null, 2));
  }

  function gql(query, variables) {
    if (!TOKEN) {
      log('No Storefront token', 'Add the Storefront API access token in the theme editor.', 'bad');
      return Promise.reject(new Error('no token'));
    }
    return fetch(URL_, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); });
  }

  /* 1 — reachability */
  root.querySelector('[data-mck-ping]').addEventListener('click', function () {
    gql('{ shop { name primaryDomain { url } } }')
      .then(function (d) {
        if (d.errors) { log('Storefront API error', d.errors, 'bad'); return; }
        log('Storefront API reachable', d.data, 'ok');
      })
      .catch(function (e) { log('Request failed', String(e), 'bad'); });
  });

  /* 2 — the crux: can we mint a customer token at all? */
  root.querySelector('[data-mck-token]').addEventListener('click', function () {
    var email = root.querySelector('[data-mck-email]').value.trim();
    var pass  = root.querySelector('[data-mck-pass]').value;
    if (!email || !pass) { log('Missing input', 'Enter an email and password.', 'bad'); return; }

    gql(
      'mutation($input: CustomerAccessTokenCreateInput!) {' +
      '  customerAccessTokenCreate(input: $input) {' +
      '    customerAccessToken { accessToken expiresAt }' +
      '    customerUserErrors { code field message }' +
      '  }' +
      '}',
      { input: { email: email, password: pass } }
    ).then(function (d) {
      if (d.errors) {
        log('Mutation rejected by Shopify', d.errors, 'bad');
        verdict(false, 'Shopify rejected customerAccessTokenCreate outright. ' +
          'On new customer accounts this mutation is commonly unavailable — ' +
          'which means a customer token cannot be minted from a password, ' +
          'and custom OTP cannot produce a checkout-aware session.');
        return;
      }
      var res = (d.data && d.data.customerAccessTokenCreate) || {};
      if (res.customerAccessToken && res.customerAccessToken.accessToken) {
        state.customerToken = res.customerAccessToken.accessToken;
        log('Customer token obtained', res.customerAccessToken, 'ok');
      } else {
        log('No token returned', res.customerUserErrors || res, 'bad');
        verdict(false, 'No customer access token was returned. If the error mentions ' +
          'unidentified customer, the account may have no password (new customer accounts). ' +
          'Try a customer you know has a password, then re-run.');
      }
    }).catch(function (e) { log('Request failed', String(e), 'bad'); });
  });

  /* 3 — cart with buyerIdentity */
  root.querySelector('[data-mck-cart]').addEventListener('click', function () {
    var variant = root.querySelector('[data-mck-variant]').value.trim();
    if (!variant) { log('Missing input', 'Paste a variant GID.', 'bad'); return; }

    var buyer = { countryCode: 'IN' };
    if (state.customerToken) buyer.customerAccessToken = state.customerToken;

    gql(
      'mutation($input: CartInput!) {' +
      '  cartCreate(input: $input) {' +
      '    cart { id checkoutUrl totalQuantity' +
      '      buyerIdentity { email phone countryCode' +
      '        customer { id firstName lastName email' +
      '          defaultAddress { address1 city province zip country } } } }' +
      '    userErrors { field message }' +
      '  }' +
      '}',
      { input: { lines: [{ merchandiseId: variant, quantity: 1 }], buyerIdentity: buyer } }
    ).then(function (d) {
      if (d.errors) { log('cartCreate error', d.errors, 'bad'); return; }
      var res = (d.data && d.data.cartCreate) || {};
      if (res.userErrors && res.userErrors.length) { log('cartCreate userErrors', res.userErrors, 'bad'); return; }

      state.cartId = res.cart.id;
      state.checkoutUrl = res.cart.checkoutUrl;
      root.querySelector('[data-mck-open]').disabled = false;

      var resolved = res.cart.buyerIdentity && res.cart.buyerIdentity.customer;
      log(resolved ? 'Cart created — customer RESOLVED on the cart'
                   : 'Cart created — but no customer attached',
          res.cart, resolved ? 'ok' : 'warn');

      if (!resolved && state.customerToken) {
        verdict(false, 'A customer token existed but the cart did not resolve a customer. ' +
          'buyerIdentity is not binding the identity, so checkout will not know who this is.');
      }
    }).catch(function (e) { log('Request failed', String(e), 'bad'); });
  });

  /* 3b — THE REAL TEST: address prefill with no customer identity */
  root.querySelector('[data-mck-prefill]').addEventListener('click', function () {
    var variant = root.querySelector('[data-mck-variant]').value.trim();
    if (!variant) { log('Missing input', 'Paste a variant GID in step 3 first.', 'bad'); return; }

    function v(sel) { return (root.querySelector(sel).value || '').trim(); }

    var address = {
      firstName: v('[data-mck-fn]'),
      lastName:  v('[data-mck-ln]'),
      address1:  v('[data-mck-a1]'),
      city:      v('[data-mck-city]'),
      province:  v('[data-mck-prov]'),      // MailingAddressInput: plain string
      zip:       v('[data-mck-zip]'),
      country:   v('[data-mck-country]'),    // MailingAddressInput: plain string
      phone:     v('[data-mck-ph]')
    };

    var buyer = {
      email: v('[data-mck-em]'),
      phone: v('[data-mck-ph]'),
      countryCode: (v('[data-mck-cc]') || 'IN').toUpperCase(),
      deliveryAddressPreferences: [{ deliveryAddress: address }]
    };

    gql(
      'mutation($input: CartInput!) {' +
      '  cartCreate(input: $input) {' +
      '    cart { id checkoutUrl' +
      '      buyerIdentity { email phone countryCode' +
      '        deliveryAddressPreferences { ... on MailingAddress {' +
      '          firstName lastName address1 city province zip country phone } } } }' +
      '    userErrors { field message }' +
      '  }' +
      '}',
      { input: { lines: [{ merchandiseId: variant, quantity: 1 }], buyerIdentity: buyer } }
    ).then(function (d) {
      if (d.errors) {
        log('cartCreate rejected', d.errors, 'bad');
        verdict(false, 'Shopify rejected the mutation. If it complains about ' +
          '<code>deliveryAddressPreferences</code>, the Storefront API version may be too old — ' +
          'try 2025-01 or later in the section settings.');
        return;
      }
      var res = (d.data && d.data.cartCreate) || {};
      if (res.userErrors && res.userErrors.length) { log('userErrors', res.userErrors, 'bad'); return; }

      var stored = res.cart.buyerIdentity && res.cart.buyerIdentity.deliveryAddressPreferences;
      var hasAddr = stored && stored.length && stored[0] && stored[0].address1;

      state.checkoutUrl = res.cart.checkoutUrl;
      root.querySelector('[data-mck-open]').disabled = false;

      log(hasAddr ? 'Cart created — address STORED on the cart'
                  : 'Cart created — but the address did NOT persist',
          res.cart, hasAddr ? 'ok' : 'bad');

      if (!hasAddr) {
        verdict(false, 'The cart accepted the mutation but did not keep the address. ' +
          'Checkout will be blank. Prefill via buyerIdentity is not available here.');
        return;
      }

      window.open(res.cart.checkoutUrl, '_blank', 'noopener');
      verdict(true,
        'The address persisted on the cart and checkout has been opened in a new tab.<br><br>' +
        '<b>Now look at that tab.</b> If the shipping address and contact fields are filled in, ' +
        'this architecture works: custom mobile-OTP login, your own address book, and a ' +
        'prefilled Shopify checkout — with no Shopify customer login at all.<br><br>' +
        'If the fields are blank despite the data being stored, Shopify is accepting the ' +
        'preference but not applying it, and we fall back to Shopify login.');
    }).catch(function (e) { log('Request failed', String(e), 'bad'); });
  });

  /* 4 — open the real checkout */
  root.querySelector('[data-mck-open]').addEventListener('click', function () {
    if (!state.checkoutUrl) return;
    window.open(state.checkoutUrl, '_blank', 'noopener');
    log('Checkout opened', state.checkoutUrl +
      '\n\nNOW LOOK AT THE CHECKOUT TAB:\n' +
      '  • Is the email / phone prefilled?\n' +
      '  • Is the shipping address prefilled?\n' +
      '  • Does it greet the customer by name?\n\n' +
      'All prefilled  → the approach works; custom OTP + working checkout is viable.\n' +
      'All blank      → checkout ignores buyerIdentity here; use Shopify login instead.', 'warn');
  });

  /* 5 — control cart, no identity */
  root.querySelector('[data-mck-plain]').addEventListener('click', function () {
    var variant = root.querySelector('[data-mck-variant]').value.trim();
    if (!variant) { log('Missing input', 'Paste a variant GID in step 3 first.', 'bad'); return; }
    gql(
      'mutation($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { message } } }',
      { input: { lines: [{ merchandiseId: variant, quantity: 1 }] } }
    ).then(function (d) {
      var url = d.data && d.data.cartCreate && d.data.cartCreate.cart && d.data.cartCreate.cart.checkoutUrl;
      if (!url) { log('Control cart failed', d, 'bad'); return; }
      state.plainUrl = url;
      window.open(url, '_blank', 'noopener');
      log('Control checkout opened', url + '\n\nCompare this blank one against step 4.', 'warn');
    });
  });

  function verdict(ok, text) {
    verdictEl.className = 'mck__verdict ' + (ok ? 'mck__verdict--ok' : 'mck__verdict--bad');
    verdictEl.innerHTML = '<b>' + (ok ? 'Viable' : 'Not viable') + '</b><br>' + text;
    verdictEl.hidden = false;
  }

  root.querySelector('[data-mck-clear]').addEventListener('click', function () {
    logEl.textContent = 'Cleared.'; statusEl.textContent = 'Ready'; verdictEl.hidden = true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-faq]').forEach(function(item){
  if (item.dataset.mcBound) return;
  item.dataset.mcBound = '1';
  var btn = item.querySelector('.mc-faq__q');
  var panel = item.querySelector('.mc-faq__a');
  btn.addEventListener('click', function(){
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('mc:auth', function (e) {
  document.querySelectorAll('[data-mc-account-label]').forEach(function (el) {
    el.textContent = e.detail.loggedIn && e.detail.firstName
      ? e.detail.firstName
      : el.dataset.mcDefault;
  });
});
document.querySelectorAll('[data-mc-header]').forEach(function(root){
  if (root.dataset.mcBound) return;
  root.dataset.mcBound = '1';
  var btn = root.querySelector('[data-mc-burger]');
  var drawer = root.querySelector('[data-mc-drawer]');
  var scrim = root.querySelector('[data-mc-scrim]');
  if (!btn || !drawer) return;
  // Portal the drawer + scrim to <body> so no ancestor stacking context
  // (.shopify-section / .mc-shell / transformed parents) can trap them
  // beneath the floating bottom nav or the sticky buy bar.
  if (scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim);
  if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
  function setOpen(open){
    btn.setAttribute('aria-expanded', String(open));
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    if (scrim){
      if (open){ scrim.hidden = false; requestAnimationFrame(function(){ scrim.classList.add('is-open'); }); }
      else { scrim.classList.remove('is-open'); setTimeout(function(){ scrim.hidden = true; }, 280); }
    }
    document.body.style.overflow = open ? 'hidden' : '';
  }
  btn.addEventListener('click', function(){
    setOpen(btn.getAttribute('aria-expanded') !== 'true');
  });
  if (scrim) scrim.addEventListener('click', function(){ setOpen(false); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') setOpen(false); });
  drawer.addEventListener('click', function(e){ if (e.target.closest('a')) setOpen(false); });
  /* ---------------- search panel ---------------- */
  var panel = root.querySelector('[data-mc-search]');
  if (panel){
    if (panel.parentNode !== document.body) document.body.appendChild(panel);
    var input = panel.querySelector('[data-mc-search-input]');
    var results = panel.querySelector('[data-mc-search-results]');
    var allLink = panel.querySelector('[data-mc-search-all]');
    var baseAll = allLink ? allLink.getAttribute('href') : '/search';
    var timer = null, lastQ = '';
    var clearBtn = panel.querySelector('[data-mc-search-clear]');

    /* SECURITY — reflected XSS, pentest finding 1.

       The no-results line used to concatenate the raw query into innerHTML:

           'No products found for \u201C' + q + '\u201D.'

       so the payload  "><img src=x onerror=alert(document.domain)>  closed
       the markup and executed. The page reads the query from the URL, so a
       crafted link fired it on load for anyone who opened it.

       Two rules now, and they are the whole fix:
         1. Anything that reaches innerHTML goes through esc() first.
         2. The user's own query never reaches innerHTML at all — it is set
            with textContent, which cannot be parsed as markup, so no later
            edit can forget to escape it. */
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;',
                 '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    /* One place that builds the plain message rows, so the safe pattern is
       the easy one to reuse. */
    function showMessage(text) {
      results.innerHTML = '';
      var msg = document.createElement('p');
      msg.className = 'mc-search__msg';
      msg.textContent = text;
      results.appendChild(msg);
    }

    /* Every product exists twice — once per city, handle-suffixed -blr/-del.
       Without this, searching "khapli" returns both and they read as
       duplicates, because the titles are identical. Defaults to Delhi, the
       same default mc-region uses. */
    function region(){
      return (window.MCRegion && window.MCRegion.current) ? window.MCRegion.current() : 'del';
    }
    function inRegion(handle){
      if (!handle) return true;
      var m = /-(blr|del)$/.exec(handle);
      return m ? m[1] === region() : true;   // not region-split: always show
    }
    function syncClear(){
      if (clearBtn) clearBtn.hidden = !(input && input.value);
    }
    // The default list is server-rendered before the pincode is known, so it
    // is filtered here rather than in Liquid.
    function filterDefault(){
      results.querySelectorAll('[data-handle]').forEach(function(row){
        row.hidden = !inRegion(row.getAttribute('data-handle'));
      });
    }
    var labelEl = panel.querySelector('[data-mc-search-label]');
    var defaultHTML = results.innerHTML;   // server-rendered "Our range" products
    function setLabel(isResults){
      if (!labelEl) return;
      labelEl.textContent = isResults
        ? (labelEl.getAttribute('data-results') || 'Results')
        : (labelEl.getAttribute('data-default') || 'Our range');
    }
    function showDefault(){
      // Safe: defaultHTML is Liquid-rendered markup captured at load, never
      // anything the customer typed.
      results.innerHTML = defaultHTML;
      filterDefault();
      setLabel(false);
      if (allLink) allLink.href = baseAll;
    }
    function searchOpen(open){
      if (open){
        panel.hidden = false;
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function(){
          panel.classList.add('is-open');
          if (input) input.focus();
        });
        syncClear();
        if (!input.value.trim()) showDefault();
      } else {
        panel.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function(){ panel.hidden = true; }, 300);
      }
    }
        /* Article excerpts arrive as HTML. Parsed in an inert DOMParser document
       rather than a detached <div>: a detached element still loads images,
       so an <img onerror> in a post would fire. DOMParser runs nothing. */
    function plain(html, max){
      if (!html) return '';
      var t = '';
      try { t = new DOMParser().parseFromString(html, 'text/html').body.textContent || ''; }
      catch (e) { t = ''; }
      t = t.replace(/\s+/g, ' ').trim();
      return t.length > max ? t.slice(0, max - 1).replace(/\s+\S*$/, '') + '\u2026' : t;
    }
    function row(url, img, title, subs){
      return '<a class="mc-search__row" href="' + esc(url) + '">' +
        '<span class="mc-search__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span><span class="mc-search__t">' + esc(title) + '</span>' +
          subs.filter(Boolean).map(function(s){ return '<span class="mc-search__s">' + esc(s) + '</span>'; }).join('') +
        '</span></a>';
    }

        /* Shopify's predictive search is loose: it matches ANY typed word, on
       tags as well as titles, with typo tolerance on top. So "khapli" can
       bring back every atta that merely shares a tag with it.
       Results are tightened in tiers, each tried only if the one above finds
       nothing:
         1. every typed word starts a word in the TITLE
         2. every typed word starts a word in the title, type, tags or size
         3. Shopify's own list, untouched
       Prefix matching, so "khap" finds Khapli mid-typing. Tier 2 keeps
       "lokwan 1kg" working; tier 3 keeps a typo like "kapli" from showing
       an empty panel. */
    function words(parts){
      return parts.join(' ').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
    }
    function hasAll(hay, terms){
      return terms.every(function(t){
        return hay.some(function(w){ return w.indexOf(t) === 0; });
      });
    }
    function allWords(products, q){
      var terms = q.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
      if (!terms.length) return products;
      var inTitle = products.filter(function(p){ return hasAll(words([p.title || '']), terms); });
      if (inTitle.length) return inTitle;
      var inAny = products.filter(function(p){
        return hasAll(words([p.title || '', p.type || '', p.product_type || '', (p.tags || []).join(' ')]
          .concat((p.variants || []).map(function(v){ return v.title || ''; }))), terms);
      });
      return inAny.length ? inAny : products;
    }
    function render(products, articles, q){
      setLabel(true);
      products = allWords(products.filter(function(p){ return inRegion(p.handle); }), q);
      articles = articles || [];
      if (!products.length && !articles.length){
        // The query goes in as text, never as markup. This is the line the
        // pentest exploited.
        showMessage('Nothing found for \u201C' + q + '\u201D.');
        return;
      }
      // Every string below is escaped — titles and excerpts are editable in
      // the admin, and "data we control today" is not "data that is safe".
      var html = products.map(function(p){
        var img = p.featured_image && p.featured_image.url;
        var variant = (p.variants && p.variants[0] && p.variants[0].title && p.variants[0].title !== 'Default Title')
          ? p.variants[0].title : '';
        return row(p.url, img, p.title, [p.product_type || p.vendor || '', variant]);
      }).join('');
      if (articles.length){
        // Products first: someone typing "khapli" most likely wants to buy
        // it. Posts follow under their own heading so a recipe is never
        // mistaken for a product.
        html += '<div class="mc-search__sec">From our blog</div>' +
          articles.map(function(a){
            var img = (a.featured_image && a.featured_image.url) || a.image || '';
            return row(a.url, img, a.title, [plain(a.summary_html, 90) || 'Read article']);
          }).join('');
      }
      results.innerHTML = html;
    }
    function run(q){
      if (!q){ showDefault(); return; }
      if (allLink) allLink.href = baseAll + '?q=' + encodeURIComponent(q);
      // One request for both. limit_scope=each applies the limit per type, so
      // eight products can never crowd out every article, or the reverse.
      // Products come back for BOTH cities and are then cut to one by
      // inRegion(), so they need the headroom; articles are not region-split.
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,article' +
        '&resources[limit]=8&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(d){
          var res = (d.resources && d.resources.results) || {};
          // A later keystroke may already have started a newer search.
          if (q !== lastQ) return;
          render(res.products || [], (res.articles || []).slice(0, 4), q);
        })
        .catch(function(){ showMessage('Search is unavailable right now.'); });
    }
    if (input){
      input.addEventListener('input', function(){
        syncClear();
        var q = input.value.trim();
        if (q === lastQ) return;
        lastQ = q;
        clearTimeout(timer);
        timer = setTimeout(function(){ run(q); }, 220);
      });
    }
        /* Enter used to submit the form to Shopify's /search page, leaving the
       panel for an unstyled default template. The panel already shows live
       results, so Enter now just runs the search immediately instead of
       waiting out the typing delay. */
    var form = panel.querySelector('.mc-search__form');
    if (form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var q = input.value.trim();
        // Cancel the pending debounce and search now. The input handler has
        // already set lastQ to this query, so clearing the timer without
        // running here would mean the search never happened at all.
        clearTimeout(timer);
        lastQ = q;
        run(q);
        // On a phone the keyboard covers half the results; Enter is the
        // natural signal that the customer is done typing.
        if (window.innerWidth <= 900) input.blur();
      });
    }
    document.addEventListener('click', function(e){
      if (e.target.closest('[data-mc-search-open]')){ e.preventDefault(); searchOpen(true); return; }
      if (e.target.closest('[data-mc-search-close]')){ searchOpen(false); return; }
      var clr = e.target.closest('[data-mc-search-clear]');
      if (clr && input){ input.value = ''; lastQ = ''; syncClear(); showDefault(); input.focus(); }
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') searchOpen(false); });
    // Changing the pincode re-runs the current search against the new city.
    document.addEventListener('mc:pin', function(){
      if (input && input.value.trim()) { lastQ = ''; run(input.value.trim()); }
      else filterDefault();
    });
    panel.querySelector('.mc-search__results').addEventListener('click', function(e){
      if (e.target.closest('a')) searchOpen(false);
    });
  }
});
/* Auto-hide header, mobile only.
   Two guards worth knowing about: a threshold so small scroll jitter does not
   flicker the header, and a hard "always show near the top" rule so it can
   never end up hidden with nowhere to scroll back to. */
(function () {
  var group = document.getElementById('header-group');
  if (!group) return;
  var lastY = window.pageYOffset || 0;
  var ticking = false;
  var THRESHOLD = 8;     // ignore anything smaller than this
  var TOP_ZONE  = 80;    // always visible within this of the top
  function onScroll() {
    var y = window.pageYOffset || 0;
    // Desktop keeps the header pinned; this behaviour is mobile only.
    if (window.innerWidth > 900) {
      group.classList.remove('mc-head-hidden');
      lastY = y;
      return;
    }
    // A drawer or modal is open — leave the header where it is.
    if (document.body.style.overflow === 'hidden') { lastY = y; return; }
    var delta = y - lastY;
    if (Math.abs(delta) < THRESHOLD) return;
    if (y < TOP_ZONE) {
      group.classList.remove('mc-head-hidden');
    } else if (delta > 0) {
      group.classList.add('mc-head-hidden');      // scrolling down
    } else {
      group.classList.remove('mc-head-hidden');   // scrolling up
    }
    lastY = y;
  }
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { onScroll(); ticking = false; });
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-hero]').forEach(function(root){
  if (root.dataset.mcBound) return;
  root.dataset.mcBound = '1';
  var track = root.querySelector('[data-mc-track]');
  var slides = root.querySelectorAll('[data-mc-slide]');
  var dots = root.querySelectorAll('[data-mc-dot]');
  var n = slides.length, i = 0, timer = null;
  var auto = root.getAttribute('data-autoplay') === 'true';
  var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
  function go(idx){
    i = (idx + n) % n;
    track.style.transform = 'translateX(-' + (i * 100) + '%)';
    dots.forEach(function(d, di){ d.classList.toggle('is-on', (di % n) === i); });
  }
  function start(){ if (auto && n > 1){ timer = setInterval(function(){ go(i + 1); }, speed); } }
  function stop(){ clearInterval(timer); }
  function restart(){ stop(); start(); }
  dots.forEach(function(d, di){ d.addEventListener('click', function(){ go(di % n); restart(); }); });
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);

  /* ── swipe ──────────────────────────────────────────────
     Pointer events cover touch, pen and mouse-drag in one path.
     The gesture is only claimed once horizontal movement clearly
     beats vertical, so the page still scrolls normally. */
  if (n > 1) {
    var viewport = root.querySelector('.mc-hero__viewport');
    var startX = 0, startY = 0, dx = 0;
    var dragging = false, decided = false, wasAuto = false;

    function width(){ return viewport.offsetWidth || 1; }

    function down(e){
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; decided = false; dx = 0;
      startX = e.clientX; startY = e.clientY;
      wasAuto = !!timer;
      stop();
    }

    function move(e){
      if (!dragging) return;
      var mx = e.clientX - startX;
      var my = e.clientY - startY;

      if (!decided) {
        // Ignore until the intent is clear; 10px of slop avoids stealing taps.
        if (Math.abs(mx) < 10 && Math.abs(my) < 10) return;
        if (Math.abs(my) > Math.abs(mx)) { dragging = false; if (wasAuto) start(); return; }
        decided = true;
        track.classList.add('is-dragging');
        if (viewport.setPointerCapture && e.pointerId !== undefined) {
          try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }

      dx = mx;
      // Resist at the ends so the carousel feels bounded, not broken.
      if ((i === 0 && dx > 0) || (i === n - 1 && dx < 0)) dx = dx * 0.35;
      track.style.transform = 'translateX(calc(' + (-i * 100) + '% + ' + dx + 'px))';
      if (e.cancelable) e.preventDefault();
    }

    function up(){
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');

      if (!decided) { if (wasAuto) start(); return; }

      var threshold = Math.min(120, width() * 0.18);
      if (dx <= -threshold && i < n - 1) go(i + 1);
      else if (dx >= threshold && i > 0) go(i - 1);
      else go(i);                       // snap back

      dx = 0;
      if (wasAuto) start();
    }

    if (window.PointerEvent) {
      viewport.addEventListener('pointerdown', down);
      viewport.addEventListener('pointermove', move, { passive: false });
      viewport.addEventListener('pointerup', up);
      viewport.addEventListener('pointercancel', up);
      viewport.addEventListener('pointerleave', up);
    } else {
      viewport.addEventListener('touchstart', function(e){ down(e.touches[0]); }, { passive: true });
      viewport.addEventListener('touchmove', function(e){
        var t = e.touches[0];
        move({ clientX: t.clientX, clientY: t.clientY, cancelable: e.cancelable,
               preventDefault: function(){ e.preventDefault(); } });
      }, { passive: false });
      viewport.addEventListener('touchend', up);
      viewport.addEventListener('touchcancel', up);
    }

    // A dragged link should not also navigate.
    viewport.addEventListener('click', function(e){
      if (Math.abs(dx) > 8) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    // Arrow keys, once the carousel has focus.
    root.setAttribute('tabindex', '-1');
    root.addEventListener('keydown', function(e){
      if (e.key === 'ArrowRight'){ go(i + 1); restart(); }
      if (e.key === 'ArrowLeft'){ go(i - 1); restart(); }
    });
  }
  document.addEventListener('shopify:block:select', function(e){
    slides.forEach(function(s, si){ if (s.getAttribute('data-block-id') === e.detail.blockId){ go(si); stop(); } });
  });
  document.addEventListener('shopify:block:deselect', restart);
  go(0); start();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-maintenance"] && !Shopify.designMode) return;
  try {
    
(function () {
  var box = document.querySelector('[data-mc-mnt-form]');
  if (!box) return;

  var mode = box.getAttribute('data-mode') || 'link';
  var key  = (box.getAttribute('data-key') || '').trim();
  var btn  = document.querySelector('[data-mc-mnt-staff]');

  // A wrong password was submitted, so Liquid already un-hid the form.
  // Leave it open and keep the toggle hidden — offering to open something
  // that is open reads as a broken control.
  if (!box.hidden) return;

  if (mode === 'url' && key) {
    // Matches ?chakki and ?chakki=1 and &chakki, but not a longer parameter
    // that merely contains the word.
    var hit = window.location.search.slice(1).split('&').some(function (part) {
      return decodeURIComponent(part.split('=')[0]) === key;
    });
    if (hit) { box.hidden = false; return; }
  }

  if (mode === 'link' && btn) {
    // The button ships hidden so it never flashes on a page where JS is
    // still loading and the mode turns out to be url or hidden.
    btn.hidden = false;
    btn.addEventListener('click', function () {
      box.hidden = false;
      btn.hidden = true;
      var i = box.querySelector('input');
      if (i) i.focus();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-process-video"] && !Shopify.designMode) return;
  try {
    
/* ── Uploaded video: poster gate, then a bare loop ── */
document.querySelectorAll('.mc-pvid [data-mc-pvid-stage]').forEach(function (stage) {
  if (stage.getAttribute('data-bound') === '1') return;
  stage.setAttribute('data-bound', '1');

  var video  = stage.querySelector('video');
  var cover  = stage.querySelector('[data-mc-pvid-cover]');
  var resume = stage.querySelector('[data-mc-pvid-resume]');
  if (!video) return;

  function showResume(on) {
    if (resume) resume.classList.toggle('is-on', !!on);
  }

  function start() {
    if (cover) cover.classList.add('is-gone');
    /* play() rejects if the browser blocks it — on a click it should not, but
       an unhandled rejection would surface as a console error, and a silent
       failure is better than noise the customer cannot act on. */
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  if (cover) {
    cover.addEventListener('click', function (e) {
      e.preventDefault();
      start();
    });
  }

  /* Click anywhere on the video toggles pause — the one control that is
     genuinely needed once the controls bar is gone. */
  stage.addEventListener('click', function (e) {
    if (cover && !cover.classList.contains('is-gone')) return;  // poster handles it
    if (e.target.closest('[data-mc-pvid-cover]')) return;
    if (video.paused) { start(); } else { video.pause(); }
  });

  video.addEventListener('play',  function () { showResume(false); });
  video.addEventListener('pause', function () { showResume(true); });
});

/* ── Embedded YouTube / Vimeo: unchanged ── */
document.querySelectorAll('.mc-pvid [data-mc-pvid-embed]').forEach(function (box) {
  if (box.getAttribute('data-bound') === '1') return;
  box.setAttribute('data-bound', '1');
  var btn = box.querySelector('.mc-pvid__play');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var src = box.getAttribute('data-src');
    if (!src) return;
    var join = src.indexOf('?') > -1 ? '&' : '?';
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src + join + 'autoplay=1');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', 'true');
    box.innerHTML = '';
    box.appendChild(iframe);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-product-main"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-pdp]').forEach(function(root){
  if (root.dataset.mcBound) return; root.dataset.mcBound='1';

  /* ---------- gallery (unchanged behaviour) ---------- */
  var main = root.querySelector('#mc-pdp-main-img');
  root.querySelectorAll('[data-mc-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      if (main) { main.src = t.getAttribute('data-full'); main.removeAttribute('srcset'); }
      root.querySelectorAll('[data-mc-thumb]').forEach(function(x){ x.classList.toggle('is-on', x===t); });
    });
  });
  var trow = root.querySelector('[data-mc-thumbs]');
  var tprev = root.querySelector('[data-mc-tprev]');
  var tnext = root.querySelector('[data-mc-tnext]');
  if (trow && tprev && tnext){
    var step = function(){ return Math.max(120, trow.clientWidth * 0.7); };
    tprev.addEventListener('click', function(){ trow.scrollBy({ left: -step(), behavior: 'smooth' }); });
    tnext.addEventListener('click', function(){ trow.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  /* ---------- variant resolution ----------
     One source of truth. Size, Mix and Texture are all real options, so
     every combination maps to an actual variant — price, MRP and
     availability come off that variant rather than being recomputed. */
  var dataEl = root.querySelector('[data-mc-variants]');
  var VARIANTS = [];
  try { VARIANTS = JSON.parse(dataEl.textContent); } catch (e) { VARIANTS = []; }

  var vidInput = root.querySelector('[data-mc-vid]');
  var priceEl  = root.querySelector('[data-mc-price]');
  var mrpEl    = root.querySelector('[data-mc-mrp]');
  var pctWrap  = root.querySelector('[data-mc-pct]');
  var pctN     = root.querySelector('[data-mc-pctn]');
  var atc      = root.querySelector('[data-mc-atc]');
  var ctas     = root.querySelector('[data-mc-region]');

  var sizeWrap = root.querySelector('[data-mc-sizes]');

  function selected(wrap, attr){
    if (!wrap) return '';
    var on = wrap.querySelector('.is-on');
    return on ? (on.getAttribute(attr) || '') : '';
  }
  function curSize(){ return selected(sizeWrap, 'data-mc-size'); }

  function find(size, mix, texture){
    for (var i=0;i<VARIANTS.length;i++){
      var v = VARIANTS[i];
      if (size && v.size !== size) continue;
      if (mix && v.mix !== mix) continue;
      if (texture && v.texture !== texture) continue;
      return v;
    }
    return null;
  }
  // Cheapest variant at a size, across every mix and texture. This page only
  // picks the size, so the card shows a "from" price and the popup resolves
  // the exact figure once mix and texture are chosen.
    // Cheapest BUYABLE variant at a size, across every mix and texture. The
  // old version took the cheapest regardless of stock — and where textures
  // tie on price, that is simply the first one, Baareek. With Baareek sold
  // out, the whole size card greyed out while Medium at the same price was
  // in stock. Falls back to the cheapest overall only when nothing at that
  // size can be bought, so a disabled card still shows a price.
  function cheapestAt(size){
    var best = null, bestAny = null;
    for (var i=0;i<VARIANTS.length;i++){
      var v = VARIANTS[i];
      if (v.size !== size) continue;
      if (!bestAny || v.price < bestAny.price) bestAny = v;
      if (v.available && (!best || v.price < best.price)) best = v;
    }
    return best || bestAny;
  }

  function paintCards(){
    if (sizeWrap){
      sizeWrap.querySelectorAll('[data-mc-size]').forEach(function(card){
        var v = cheapestAt(card.getAttribute('data-mc-size'));
        var p = card.querySelector('[data-mc-card-price]');
        var s = card.querySelector('[data-mc-card-cmp]');
        if (!v){ card.classList.add('is-off'); card.disabled = true; return; }
        card.classList.toggle('is-off', !v.available);
        card.disabled = !v.available;
        if (p) p.textContent = v.price_f;
        if (s){
          var show = v.compare > v.price;
          s.hidden = !show;
          s.textContent = show ? v.compare_f : '';
        }
      });
    }
  }

  function fmt(cents){
    var n = cents/100;
    return '\u20B9' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function apply(){
    // Cheapest variant at this size. The popup resolves the exact variant
    // once mix and texture are chosen, so this is the "from" price.
    var v = cheapestAt(curSize()) || VARIANTS[0];
    if (!v) return;
    if (vidInput) vidInput.value = v.id;
    if (priceEl) priceEl.textContent = v.price_f;
    if (mrpEl) mrpEl.textContent = v.compare > v.price ? v.compare_f : v.price_f;
    var pct = v.compare > v.price ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;
    if (pctWrap){ pctWrap.hidden = pct <= 0; if (pctN) pctN.textContent = pct; }
    if (atc){
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to Cart' : 'Sold Out';
    }
    paintCards();
    // Carry the chosen size onto the CTAs, otherwise the popup would always
    // open on whichever size happened to load first.
    root.querySelectorAll('[data-mc-cz-btn]').forEach(function(b){
      b.setAttribute('data-weight', curSize());
    });
    document.dispatchEvent(new CustomEvent('mc:variant', { detail: { id: v.id, variant: v } }));
  }

  function pick(wrap, card){
    if (!wrap || card.disabled) return;
    wrap.querySelectorAll('.mc-pdp__wcard').forEach(function(c){ c.classList.toggle('is-on', c===card); });
    apply();
  }

  if (sizeWrap) sizeWrap.addEventListener('click', function(e){
    var c = e.target.closest('[data-mc-size]'); if (c) pick(sizeWrap, c);
  });
  apply();

    /* ---------- MoEngage: Product Viewed ----------
     MoEngage fires this automatically only on Shopify's DEFAULT product
     template. This PDP is custom, so the event never fires on its own.

     Values come from data attributes, NOT Liquid: javascript blocks are
     served as a static asset and are never rendered by Liquid, so a { } in
     here reaches the browser as literal text and throws a SyntaxError that
     kills this whole file.

     The SDK is injected by the MoEngage app and may load after this section,
     so poll briefly rather than firing once and missing it. */
  (function () {
    var tries = 0;
    (function fire() {
      if (window.Moengage && typeof Moengage.track_event === 'function') {
        var v = cheapestAt(curSize()) || VARIANTS[0] || {};
        try {
          Moengage.track_event('Product Viewed', {
            'Product ID': root.getAttribute('data-pid') || '',
            'Product Title': root.getAttribute('data-ptitle') || '',
            'Product Handle': root.getAttribute('data-phandle') || '',
            'Variation ID': String(v.id || ''),
            'Price': (v.price || 0) / 100,
            'Currency': root.getAttribute('data-pcurrency') || 'INR',
            'Available': root.getAttribute('data-pavailable') === 'true',
            'Total Variants': VARIANTS.length,
            'URL': window.location.href
          });
        } catch (err) { console.warn('[mc-pdp] MoEngage event failed', err); }
        return;
      }
      if (++tries < 25) setTimeout(fire, 200);
    })();
  })();

  /* ---------- benefits toggle ---------- */
  var tog = root.querySelector('[data-mc-ing-toggle]');
  var grid = root.querySelector('[data-mc-ing-grid]');
  var list = root.querySelector('[data-mc-ing-list]');
  if (tog && grid && list){
    tog.addEventListener('click', function(){
      var on = tog.getAttribute('aria-expanded') === 'true';
      tog.setAttribute('aria-expanded', String(!on));
      grid.hidden = !on;
      list.hidden = on;
    });
  }

  /* ---------- cutoff countdown ---------- */
  var cd = root.querySelector('[data-mc-countdown]');
  if (cd){
    var cutoff = parseInt(root.getAttribute('data-cutoff'),10); if (isNaN(cutoff)) cutoff = 16;
    function tick(){
      var now = new Date(); var end = new Date(now);
      end.setHours(cutoff,0,0,0);
      if (end <= now) end.setDate(end.getDate()+1);
      var mins = Math.floor((end-now)/60000);
      cd.textContent = Math.floor(mins/60) + 'h ' + (mins%60) + 'mins';
    }
    tick(); setInterval(tick, 30000);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-product-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* One viewer for the whole page, shared by every review section. */
  var MCLightbox = window.MCLightbox || (window.MCLightbox = (function () {
    var box, img, cap, count, prev, next, list = [], at = 0, lastFocus = null, sx = null;
    var ICON = {
      x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
      l: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
      r: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'
    };
    function btn(cls, label, icon) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mc-lb__btn ' + cls;
      b.setAttribute('aria-label', label); b.innerHTML = icon;
      return b;
    }
    function build() {
      box = document.createElement('div');
      box.className = 'mc-lb'; box.hidden = true;
      box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Review photo');
      cap = box.appendChild(document.createElement('div')); cap.className = 'mc-lb__cap';
      img = box.appendChild(document.createElement('img')); img.className = 'mc-lb__img'; img.alt = '';
      var x = box.appendChild(btn('mc-lb__x', 'Close', ICON.x));
      prev = box.appendChild(btn('mc-lb__prev', 'Previous photo', ICON.l));
      next = box.appendChild(btn('mc-lb__next', 'Next photo', ICON.r));
      count = box.appendChild(document.createElement('div')); count.className = 'mc-lb__count';
      // Straight into <body>: an ancestor with a transform would trap position:fixed.
      document.body.appendChild(box);
      x.addEventListener('click', close);
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') go(-1);
        else if (e.key === 'ArrowRight') go(1);
      });
      box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      });
    }
    function show() {
      var u = list[at];
      img.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
      var many = list.length > 1;
      prev.hidden = next.hidden = count.hidden = !many;
      count.textContent = (at + 1) + ' / ' + list.length;
    }
    function go(d) {
      if (list.length < 2) return;
      at = (at + d + list.length) % list.length;
      show();
    }
    function open(urls, start, who) {
      if (!box) build();
      list = urls; at = start || 0;
      cap.textContent = who ? 'Photo from ' + who : '';
      lastFocus = document.activeElement;
      show();
      box.hidden = false;
      document.body.classList.add('mc-lb-locked');
      box.querySelector('.mc-lb__x').focus();
    }
    function close() {
      if (!box || box.hidden) return;
      box.hidden = true;
      img.removeAttribute('src');
      document.body.classList.remove('mc-lb-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    return { open: open, close: close };
  })());

  document.querySelectorAll('[data-mc-reviews]').forEach(function (root) {
    if (root.dataset.mcBound) return;
    root.dataset.mcBound = '1';

    /* Photo viewer. A tap on a review photo opens it here, over the page,
       with the other photos from the same review a swipe or arrow away.
       The photos stay plain links underneath, so without JavaScript they
       still open as before. */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('.mc-ptc__ph');
      if (!a || !root.contains(a)) return;
      var card = a.closest('.mc-ptc');
      var links = [].slice.call((card || a.parentNode).querySelectorAll('.mc-ptc__ph'));
      var urls = links.map(function (l) { return l.getAttribute('href'); })
        .filter(function (u) { return u && u.indexOf('https://cdn.shopify.com/') === 0; });
      if (!urls.length) return;
      e.preventDefault();
      var who = card && card.querySelector('.mc-ptc__meta b');
      MCLightbox.open(urls, Math.max(0, urls.indexOf(a.getAttribute('href'))), who ? who.textContent : '');
    });

    var openBtn = root.querySelector('[data-mc-review-open]');
    if (!openBtn) return;
    var handle = root.getAttribute('data-handle');
    var title = root.getAttribute('data-title');

    /* The popup is the shared one from snippets/mc-review (MCReview), the
       same form the orders page uses. This section only opens it and puts
       the new review on the page afterwards. */
    function start() {
      if (!window.MCReview || openBtn.disabled) return;
      window.MCReview.open({
        kind: 'product', handle: handle, title: title,
        onDone: function (rv) {
          if (rv) paintCard(rv);
          markReviewed(true);
        }
      });
    }

    /* A customer who has already reviewed this atta from its product page
       sees "Reviewed" instead of the button — one product-page review each,
       and reviews can't be edited. Order reviews don't count here: those
       are reviews of an order, and leave this one available. */
    var label = openBtn.innerHTML;
    var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    function markReviewed(on) {
      openBtn.disabled = on;
      openBtn.innerHTML = on ? TICK + 'Reviewed' : label;
      if (on) openBtn.setAttribute('aria-label', 'You have reviewed this atta');
      else openBtn.removeAttribute('aria-label');
    }
    function api() { return (window.MC_API_BASE || 'https://api.aashirvaadchakki.com').replace(/\/+$/, ''); }
    var asked = 0;
    function checkReviewed() {
      var ask = ++asked;
      return fetch(api() + '/reviews/mine?handle=' + encodeURIComponent(handle), { credentials: 'include' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (ask === asked) markReviewed(!!(d && d.reviewed)); })
        .catch(function () {});              // unknown: leave the button usable
    }
    // Signed-out visitors keep the button (it leads to sign-in), so only ask
    // mc-api once we know someone is signed in.
    var auth = window.MCAuth;
    var signedIn = (auth && typeof auth.check === 'function') ? auth.check() : Promise.resolve(false);
    var ready = Promise.resolve(signedIn).then(function (isIn) { return isIn ? checkReviewed() : null; })
      .catch(function () {});
    document.addEventListener('mc:auth', function (e) {
      if (e.detail && e.detail.loggedIn) checkReviewed();
      else { asked++; markReviewed(false); }
    });

    /* The new review appears at the front of the row without a reload,
       built with textContent throughout. */
    var STAR = 'M8.5 0l2.1 5.2 5.4.4-4.1 3.6 1.3 5.3L8.5 11.6 3.3 14.5l1.3-5.3L.5 5.6l5.4-.4z';
    var NS = 'http://www.w3.org/2000/svg';
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function paintCard(rv) {
      var row = root.querySelector('[data-mc-review-row]');
      var empty = root.querySelector('[data-mc-review-empty]');
      if (empty) empty.remove();
      var old = row.querySelector('[data-mine]');
      if (old) old.remove();

      var card = el('div', 'mc-ptc');
      card.setAttribute('data-mine', '');
      // Only mc-api decides "verified" — a non-buyer's review has no badge.
      if (rv.verified) card.appendChild(el('span', 'mc-ptc__badge', 'Verified buyer'));
      card.appendChild(el('p', null, '“' + rv.quote + '”'));
      if (rv.photos && rv.photos.length) {
        var ph = el('div', 'mc-ptc__photos');
        rv.photos.forEach(function (u) {
          if (u.indexOf('https://cdn.shopify.com/') !== 0) return;
          var a = el('a', 'mc-ptc__ph');
          a.href = u; a.target = '_blank'; a.rel = 'noopener';
          var i = el('img'); i.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200'; i.alt = '';
          a.appendChild(i); ph.appendChild(a);
        });
        card.appendChild(ph);
      }
      var who = el('div', 'mc-ptc__who');
      var meta = el('div', 'mc-ptc__meta');
      meta.appendChild(el('b', null, rv.name));
      meta.appendChild(el('small', null, [rv.location, 'Just now'].filter(Boolean).join(' · ')));
      var stars = el('span', 'mc-ptc__stars');
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', rv.stars + ' out of 5');
      for (var k = 1; k <= 5; k++) {
        var s = document.createElementNS(NS, 'svg');
        s.setAttribute('viewBox', '0 0 17 16');
        s.setAttribute('fill', k <= rv.stars ? '#F6AE2D' : '#D9D9D9');
        var p = document.createElementNS(NS, 'path'); p.setAttribute('d', STAR);
        s.appendChild(p); stars.appendChild(s);
      }
      meta.appendChild(stars);
      who.appendChild(meta);
      card.appendChild(who);
      row.insertBefore(card, row.firstChild);
      row.scrollLeft = 0;
    }

    openBtn.addEventListener('click', start);

    // ?review=1 — the "Order delivered" email links here with it. Waits for
    // the Reviewed check, so someone who has reviewed just sees "Reviewed".
    try {
      if (new URLSearchParams(location.search).get('review') === '1') {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        ready.then(function () { setTimeout(start, 400); });
      }
    } catch (e) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-shop-by-nutrition-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-nut]').forEach(function (root) {
  if (root.dataset.mcNutBound) return;
  root.dataset.mcNutBound = '1';
  var side   = root.querySelector('[data-mc-nut-side]');
  var scrim  = root.querySelector('[data-mc-nut-scrim]');
  var grid   = root.querySelector('[data-mc-nut-grid]');
  var empty  = root.querySelector('[data-mc-nut-empty]');
  var fabDot = root.querySelector('[data-mc-nut-fabcount]');
  var items  = Array.prototype.slice.call(root.querySelectorAll('[data-mc-nut-item]'));
  var cats   = Array.prototype.slice.call(root.querySelectorAll('[data-mc-nut-cat]'));
  var preselect = root.getAttribute('data-preselect') === 'true';
  var activeCat = null;
  function tagsOf(el) {
    return (el.getAttribute('data-tags') || '')
      .split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
  }
  /* products belonging to the active category (all of them if none active) */
  function inCategory() {
    return items.filter(function (i) {
      return !activeCat || i.getAttribute('data-cat') === activeCat;
    });
  }
  /* selections: OR within a group, AND across groups */
  function selections() {
    var groups = [];
    root.querySelectorAll('[data-mc-nut-group]').forEach(function (g) {
      var picked = [];
      g.querySelectorAll('[data-mc-nut-input]').forEach(function (i) {
        if (i.checked) picked.push(i.value.toLowerCase());
      });
      if (picked.length) groups.push(picked);
    });
    return groups;
  }
  function matches(item, groups) {
    var tags = tagsOf(item);
    return groups.every(function (g) {
      return g.some(function (t) { return tags.indexOf(t) !== -1; });
    });
  }
  /* counts recalculate against the active category, excluding that option's
     own group so the numbers behave like every other faceted filter */
  function refreshCounts() {
    var pool = inCategory();
    root.querySelectorAll('[data-mc-nut-group]').forEach(function (g) {
      var otherGroups = [];
      root.querySelectorAll('[data-mc-nut-group]').forEach(function (og) {
        if (og === g) return;
        var picked = [];
        og.querySelectorAll('[data-mc-nut-input]').forEach(function (i) {
          if (i.checked) picked.push(i.value.toLowerCase());
        });
        if (picked.length) otherGroups.push(picked);
      });
      g.querySelectorAll('[data-mc-nut-input]').forEach(function (input) {
        var tag = input.value.toLowerCase();
        var n = pool.filter(function (item) {
          return tagsOf(item).indexOf(tag) !== -1 && matches(item, otherGroups);
        }).length;
        var out = input.parentNode.querySelector('[data-mc-nut-count]');
        if (out) out.textContent = n < 10 ? '0' + n : String(n);
        input.parentNode.classList.toggle('is-empty', n === 0 && !input.checked);
      });
    });
  }
  function apply() {
    var groups = selections();
    var count = groups.reduce(function (n, g) { return n + g.length; }, 0);
    var shown = 0;
    items.forEach(function (item) {
      var ok = (!activeCat || item.getAttribute('data-cat') === activeCat) && matches(item, groups);
      item.hidden = !ok;
      if (ok) shown++;
    });
    if (empty) empty.hidden = shown !== 0;
    if (grid) grid.hidden = shown === 0;
    if (fabDot) { fabDot.textContent = count; fabDot.hidden = count === 0; }
    refreshCounts();
  }
  /* category strip: single select, always one active */
  cats.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activeCat = btn.getAttribute('data-mc-nut-cat');
      cats.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
      if (grid) grid.scrollLeft = 0;
      apply();
    });
  });
  root.querySelectorAll('[data-mc-nut-input]').forEach(function (input) {
    input.addEventListener('change', apply);
  });
  root.querySelectorAll('[data-mc-nut-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
  });
  var clear = root.querySelector('[data-mc-nut-clear]');
  if (clear) {
    clear.addEventListener('click', function () {
      root.querySelectorAll('[data-mc-nut-input]').forEach(function (i) { i.checked = false; });
      apply();
    });
  }
  /* mobile sheet */
  function sheet(open) {
    if (!side) return;
    side.classList.toggle('is-open', open);
    if (scrim) {
      if (open) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-open'); }); }
      else { scrim.classList.remove('is-open'); setTimeout(function () { scrim.hidden = true; }, 280); }
    }
    document.body.style.overflow = open ? 'hidden' : '';
  }
  var openBtn = root.querySelector('[data-mc-nut-open]');
  if (openBtn) openBtn.addEventListener('click', function () { sheet(true); });
  root.querySelectorAll('[data-mc-nut-close]').forEach(function (b) {
    b.addEventListener('click', function () { sheet(false); });
  });
  if (scrim) scrim.addEventListener('click', function () { sheet(false); });
  var applyBtn = root.querySelector('[data-mc-nut-apply]');
  if (applyBtn) applyBtn.addEventListener('click', function () { apply(); sheet(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sheet(false); });
  /* first category active on load */
  if (preselect && cats.length) {
    activeCat = cats[0].getAttribute('data-mc-nut-cat');
    cats[0].classList.add('is-on');
  }
  apply();
  /* never open on an empty grid */
  if (preselect && activeCat && items.filter(function (i) { return !i.hidden; }).length === 0) {
    activeCat = null;
    cats.forEach(function (b) { b.classList.remove('is-on'); });
    apply();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-shop-by-nutrition"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-nutri]').forEach(function(root){
  if (root.dataset.mcBound) return;
  root.dataset.mcBound = '1';
  var tabs = root.querySelectorAll('[data-mc-tab]');
  var panels = root.querySelectorAll('[data-mc-panel]');
  function activePanelScroll(){
    var p = root.querySelector('[data-mc-panel].is-on [data-mc-scroll]');
    return p || null;
  }
  tabs.forEach(function(tab){
    function activate(){
      var idx = tab.getAttribute('data-mc-tab');
      tabs.forEach(function(t){ t.classList.toggle('is-on', t === tab); });
      panels.forEach(function(p){ p.classList.toggle('is-on', p.getAttribute('data-mc-panel') === idx); });
    }
    tab.addEventListener('click', activate);
    tab.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); } });
  });
  var prev = root.querySelector('[data-mc-prev]');
  var next = root.querySelector('[data-mc-next]');
  if (prev) prev.addEventListener('click', function(){ var s = activePanelScroll(); if (s) s.scrollBy({ left: -345, behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function(){ var s = activePanelScroll(); if (s) s.scrollBy({ left: 345, behavior: 'smooth' }); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-sticky-buybar"] && !Shopify.designMode) return;
  try {
    
/* Shared cart state. Also defined, identically and behind the same guard, in
   mc-product-card — whichever loads first wins. It lives in both because
   either can be on a page without the other, and the sticky bar must not
   depend on a card section happening to be rendered below it. */
(function(){
  if (window.MCCardCart) return;
  var listeners = [], last = null, inflight = null;
  function set(cart){
    if (!cart || !cart.items) return;
    last = cart;
    listeners.forEach(function(fn){ try { fn(cart); } catch (e) { console.warn('[mc-cart]', e); } });
  }
  function load(){
    if (inflight) return inflight;
    inflight = fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){ inflight = null; set(c); return c; })
      .catch(function(){ inflight = null; return last; });
    return inflight;
  }
  document.addEventListener('mc:cart:updated', function(e){
    if (e.detail && e.detail.cart) set(e.detail.cart); else load();
  });
  document.addEventListener('mc:cart:added', function(){ load(); });
  window.addEventListener('pageshow', function(e){ if (e.persisted) load(); });
  window.MCCardCart = {
    on: function(fn){ listeners.push(fn); if (last) fn(last); },
    load: load
  };
  load();
})();

document.querySelectorAll('[data-mc-sticky]').forEach(function(bar){
  if (bar.dataset.mcBound) return;
  bar.dataset.mcBound = '1';
  var always = bar.getAttribute('data-always') === 'true';
  if (always){
    bar.classList.add('is-on');
  } else {
    var offset = parseInt(bar.getAttribute('data-offset'), 10);
    if (isNaN(offset)) offset = 500;
    var onScroll = function(){ bar.classList.toggle('is-on', window.scrollY > offset); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  // keep page content clear of the fixed bar
  var pad = function(){ document.body.style.paddingBottom = bar.offsetHeight + 'px'; };
  pad();
  window.addEventListener('resize', pad);

  var czWrap   = bar.querySelector('[data-mc-sticky-cz]');
  var handle   = czWrap ? czWrap.getAttribute('data-handle') : '';
  var buyBtn   = bar.querySelector('.mc-sticky__buy');
  var atcBtn   = bar.querySelector('.mc-sticky__atc[data-mc-sticky-btn]');
  var stepWrap = bar.querySelector('[data-mc-sticky-step]');
  var stepN    = bar.querySelector('[data-mc-sn]');
  var lastCart = null;
  var isCustom = czWrap && czWrap.getAttribute('data-custom') === 'true';
  // The variant for the selected size. On a product with no mix or texture
  // there is exactly one per size, so this IS the item to add. Starts from
  // the server-rendered variant and follows mc:variant as the size changes.
  var curVid = czWrap ? czWrap.getAttribute('data-vid') : '';

  /* Size sync. mc-product-main fires mc:variant carrying the whole variant,
     so the size comes from there. mc:weight is still honoured for any older
     section that emits it. Without this the popup would always open on
     whichever size loaded first — someone who switched to 5kg would be
     charged for 2kg. */
  var curWeight = null;
  function setWeight(w){
    if (!w) return;
    curWeight = w;
    bar.querySelectorAll('[data-mc-sticky-btn]').forEach(function(b){
      b.setAttribute('data-weight', w);
    });
    paint();
  }
  var firstBtn = bar.querySelector('[data-mc-sticky-btn]');
  if (firstBtn) curWeight = firstBtn.getAttribute('data-weight') || null;

  /* Per-size availability. The bar is rendered once for the whole product,
     so without this a sold-out size kept a live Add to Cart that opened the
     popup on nothing buyable. */
  /* Two independent reasons the buttons can be off, combined here so one
     never re-enables what the other disabled: the chosen size can be sold
     out (mc:variant), or this listing is for a city the customer's pincode
     is not in and has no twin there (mc:region). The region case used to
     have no effect on this bar at all — the notice showed, but Buy Now
     still worked, which is how a Bengaluru-only product reached Faridabad. */
  var sizeAvailable = true;
  var regionBlocked = !!(window.MCRegion && window.MCRegion.state &&
                         window.MCRegion.state().status === 'blocked');
  function applyState(){
    var ok = sizeAvailable && !regionBlocked;
    [buyBtn, atcBtn].forEach(function(b){ if (b) b.disabled = !ok; });
    if (atcBtn) atcBtn.textContent = regionBlocked ? 'Not available here' : (ok ? 'Add to Cart' : 'Sold Out');
    paint();
  }
  function setAvailable(ok){
    sizeAvailable = ok;
    applyState();
  }
  document.addEventListener('mc:region', function(e){
    regionBlocked = !!(e.detail && e.detail.status === 'blocked');
    applyState();
  });

  document.addEventListener('mc:variant', function(e){
    if (!e.detail || !e.detail.variant) return;
    var v = e.detail.variant;
    if (v.id) curVid = String(v.id);
    if (typeof v.available === 'boolean') setAvailable(v.available);
    if (v.size) setWeight(v.size);
  });
  document.addEventListener('mc:weight', function(e){
    if (e.detail) setWeight(e.detail.weight);
  });

  /* Cart lines for this product at the size currently selected. Matched on
     the Size option rather than the variant id, because on Lokwan and
     Sharbati one size spans several variants — every texture and mix. */
  function linesFor(cart){
    if (!cart || !cart.items) return [];
    return cart.items.filter(function(it){
      if (it.handle !== handle) return false;
      if (!curWeight) return true;
      var opts = it.options_with_values || [];
      var wo = opts.filter(function(o){ return /size|weight/i.test(o.name); })[0];
      return wo ? wo.value === curWeight : true;
    });
  }
  function paint(cart){
    if (cart) lastCart = cart;
    if (!stepWrap || !atcBtn) return;
    var qty = linesFor(lastCart).reduce(function(n, it){ return n + it.quantity; }, 0);
    // A blocked listing never shows the stepper: its + would add more of a
    // product that cannot be delivered to this pincode.
    if (regionBlocked) qty = 0;
    stepWrap.hidden = qty === 0;
    atcBtn.hidden = qty > 0;
    if (stepN && qty > 0) stepN.textContent = qty;
  }
  function bump(delta){
    var lines = linesFor(lastCart);
    if (!lines.length) return;
    // Several lines can share a size (1kg Baareek, 1kg Medium Millet). The
    // stepper adjusts the most recently added; the drawer lists each one.
    var line = lines[lines.length - 1];
    var next = Math.max(0, line.quantity + delta);
    if (window.MCCart && window.MCCart.change){
      window.MCCart.change(line.key, next);
      return;
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: next })
    })
      .then(function(r){ return r.json(); })
      .then(function(c){
        // Broadcast, so the cards, drawer and nav badge all move together.
        document.dispatchEvent(new CustomEvent('mc:cart:updated', { detail: { cart: c } }));
      })
      .catch(function(){});
  }

  /* Straight to the cart, for products with nothing to customise. Buy Now
     still goes through the address picker rather than Shopify's checkout
     directly, exactly as the popup does after its own add. */
  function directAdd(btn, mode){
    if (!curVid || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = mode === 'buy' ? 'Please wait…' : 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: curVid, quantity: 1 })
    })
      .then(function(r){
        return r.json().catch(function(){ return {}; }).then(function(d){
          // Shopify puts the real reason in `description` — "sold out",
          // "only N available" — which beats a generic retry message.
          if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.');
          return d;
        });
      })
      .then(function(){ return window.MCCardCart.load(); })
      .then(function(cart){
        document.dispatchEvent(new CustomEvent('mc:cart:updated', { detail: { cart: cart } }));
        if (mode === 'buy'){
          if (window.MCCheckout && typeof window.MCCheckout.open === 'function') window.MCCheckout.open();
          else window.location.href = '/checkout';   // picker absent: never block the sale
          return;
        }
        if (window.MCCart && typeof window.MCCart.open === 'function') window.MCCart.open();
      })
      .catch(function(err){ alert(err && err.message ? err.message : 'Could not add to cart.'); })
      .then(function(){ btn.disabled = false; btn.textContent = label; });
  }

  if (czWrap){
    czWrap.querySelectorAll('[data-cz-mode]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (regionBlocked || btn.disabled) return;   // belt and braces
        var mode = btn.getAttribute('data-cz-mode');
        if (!isCustom) return directAdd(btn, mode);
        if (!window.MCCustomise) return;   // mc-base not loaded — do nothing rather than throw
        window.MCCustomise.open({
          handle: handle,
          weight: btn.getAttribute('data-weight') || curWeight,
          mode: mode
        });
      });
    });
  }
  if (stepWrap){
    stepWrap.querySelector('[data-mc-sdec]').addEventListener('click', function(){ bump(-1); });
    stepWrap.querySelector('[data-mc-sinc]').addEventListener('click', function(){ bump(1); });
  }
  window.MCCardCart.on(paint);
  if (regionBlocked) applyState();
});

  } catch(e) { console.error(e); }
})();
})();
